<template>
  <div class="form-page">
    <div class="form-page__header">
      <h2 class="form-page__title">Zusammenfassung &amp; Bestätigung</h2>
      <p class="form-page__subtitle">Bitte prüfen Sie Ihre Angaben vor dem Absenden.</p>
    </div>

    <div class="info-box info-box--green" style="margin-bottom: 24px;">
      <span class="info-box__icon">✅</span>
      <div>
        <strong>Antrag vollständig ausgefüllt</strong>
        <p>Alle Pflichtfelder wurden erfasst. Sie können den Antrag jetzt absenden.</p>
      </div>
    </div>

    <!-- Section: eID -->
    <div class="summary-section">
      <div class="summary-section__title">Online-Ausweisfunktion (eID)</div>
      <div class="summary-row">
        <span class="summary-row__label">eID-Nutzung</span>
        <span class="summary-row__value">
          {{ modelValue.id_verwendung === true ? 'Ja' : modelValue.id_verwendung === false ? 'Nein' : '–' }}
        </span>
      </div>
    </div>

    <!-- Section: Persönliche Daten -->
    <div class="summary-section">
      <div class="summary-section__title">Persönliche Daten</div>
      <div class="summary-row">
        <span class="summary-row__label">Anrede</span>
        <span class="summary-row__value">{{ modelValue.anrede || '–' }}</span>
      </div>
      <div class="summary-row" v-if="modelValue.titel">
        <span class="summary-row__label">Titel</span>
        <span class="summary-row__value">{{ modelValue.titel }}</span>
      </div>
      <div class="summary-row" v-if="modelValue.kuenstlername">
        <span class="summary-row__label">Künstlername</span>
        <span class="summary-row__value">{{ modelValue.kuenstlername }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-row__label">Vorname</span>
        <span class="summary-row__value">{{ modelValue.vorname || '–' }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-row__label">Nachname</span>
        <span class="summary-row__value">{{ modelValue.nachname || '–' }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-row__label">Geschlecht</span>
        <span class="summary-row__value">{{ modelValue.geschlecht || '–' }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-row__label">Geburtsdatum</span>
        <span class="summary-row__value">{{ formatDate(modelValue.geburtsdatum) }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-row__label">Geburtsort</span>
        <span class="summary-row__value">{{ modelValue.geburtsort || '–' }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-row__label">Staatsangehörigkeit</span>
        <span class="summary-row__value">{{ modelValue.staatsangehoerigkeit || '–' }}</span>
      </div>
    </div>

    <!-- Section: Kontakt & Adresse -->
    <div class="summary-section">
      <div class="summary-section__title">Kontakt &amp; Adresse</div>
      <div class="summary-row">
        <span class="summary-row__label">E-Mail</span>
        <span class="summary-row__value">{{ modelValue.email || '–' }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-row__label">Telefon</span>
        <span class="summary-row__value">{{ modelValue.telefon || '–' }}</span>
      </div>
      <div class="summary-row" v-if="modelValue.mobil">
        <span class="summary-row__label">Mobil</span>
        <span class="summary-row__value">{{ modelValue.mobil }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-row__label">Adresse</span>
        <span class="summary-row__value">
          {{ modelValue.strasse }} {{ modelValue.hausnummer }}, {{ modelValue.plz }} {{ modelValue.ort }}
        </span>
      </div>
    </div>

    <div class="info-box info-box--yellow" style="margin-top: 8px;">
      <span class="info-box__icon">ℹ️</span>
      <div>
        <strong>Showcase-Hinweis</strong>
        <p>Dies ist eine Demo-Umgebung. Es werden keine echten Daten übermittelt.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LitStep5',
  props: {
    modelValue: { type: Object, required: true },
    showErrors: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  setup() {
    const formatDate = (val) => {
      if (!val) return '–';
      const d = new Date(val);
      if (isNaN(d)) return val;
      return d.toLocaleDateString('de-DE');
    };
    return { formatDate };
  },
};
</script>

<style scoped src="../form.css"></style>
